import { Component, Inject, inject } from '@angular/core';
import { RoutingService } from '@nano/common/routing';
import { AuthService, UserProfile } from '@nano/core/auth';
import { CONFIG } from '@nano/core/config';
import { L10nService } from '@nano/core/l10n';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
  standalone: false
})
export class FooterComponent {
  readonly currentYear: number = new Date().getFullYear();
  readonly multilingual$ = this.l10nService.multilingual$;
  readonly userProfile$: Observable<UserProfile> = this.authService.userProfile$;

  bankName: string;
  bankSupportEmail: string;
  footerNavEnabled: boolean;
  footerAdditionalInfoEnabled: boolean;

  private config = inject(CONFIG);

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private authService: AuthService,
    private l10nService: L10nService,
    private routingService: RoutingService,
    private translationService: L10nTranslationService
  ) {
    this.bankName = this.config.bankName;
    this.bankSupportEmail = this.config.bankSupportEmail;
    this.footerNavEnabled = this.config.footerNavEnabled;
    this.footerAdditionalInfoEnabled = this.config.footerAdditionalInfoEnabled;
  }

  navigateToAccounts(): void {
    this.routingService.navigateToRoot();
  }

  hasTranslation(key: string): boolean {
    return this.translationService.translate(key) !== key;
  }
}
